<template>
  <div class="instock-dialog-bd">
    <custom-dialog width="1200px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <el-form :model="form" ref="form">
          <el-form-item :label="$t('dms_instock_dialog.ru_ku_dan_hao')" prop="shipmentNum" :rules="rules.shipmentNum">
            <el-input v-model="form.shipmentNum" style="width: 220px"></el-input>
          </el-form-item>
        </el-form>
        <!-- 入库信息 -->
        <div class="handle-role">
          <div class="role-list">
            <ul>
              <li>
                <div class="item-head ub">
                  <el-row :gutter="10" class="ub-f1">
                    <el-col :span="4">
                      <h1>{{ $t('dms_instock_dialog.chan_pinSN') }}</h1>
                    </el-col>
                    <el-col :span="4">
                      <h1>
                        {{ $t('dms_instock_dialog.chan_pin_xing_hao') }}
                      </h1>
                    </el-col>
                    <el-col :span="4">
                      <h1>
                        {{ $t('dms_instock_dialog.ji_shen_hao') }}
                      </h1>
                    </el-col>
                    <el-col :span="4">
                      <h1>
                        {{ 'Modem SN' }}
                      </h1>
                    </el-col>
                    <el-col :span="4">
                      <h1>
                        {{ $t('dms_instock_dialog.ru_ku_ban_li_ren') }}
                      </h1>
                    </el-col>
                    <el-col :span="4">
                      <h1>
                        {{ $t('dms_instock_dialog.ru_ku_shi_jian') }}
                      </h1>
                    </el-col>
                  </el-row>
                  <div class="icon-box"></div>
                </div>
                <div class="children">
                  <div class="item ub" v-for="(item, index) in productList" :key="index">
                    <el-row :gutter="10" class="ub-f1">
                      <!-- 产品型号 -->
                      <el-col :span="4">
                        <!-- <el-select
                          v-model="item.productSn"
                          :placeholder="index !== 0 ? $t('page_content_default_up : $t('com_please_select"
                          style="width: 100%"
                        >
                          <el-option v-for="items in productOptions" :key="items.productSn" :label="items.codeSn" :value="items.productSn"></el-option>
                        </el-select> -->
                        <custom-select
                          url="ProductModelList"
                          v-model="item.productSn"
                          :placeholder="index !== 0 ? $t('dms_instock_dialog.mo_ren_tong_shang') : $t('Common.com_please_select')"
                          :props="{ label: 'codeSn', value: 'productSn' }"
                          @change="changProductSn(arguments[0], item)"
                        ></custom-select>
                      </el-col>
                      <el-col :span="4">
                        <el-input v-model="item.productCode" disabled style="width: 100%"></el-input>
                      </el-col>
                      <!-- 机身号 -->
                      <el-col :span="4">
                        <el-input v-model="item.bodyNum" style="width: 100%"></el-input>
                      </el-col>
                      <!-- Modem SN -->
                      <el-col :span="4">
                        <el-input v-model="item.modemSn" style="width: 100%"></el-input>
                      </el-col>
                      <!-- 入库办理人 -->
                      <el-col :span="4">
                        <el-input :placeholder="index !== 0 ? $t('dms_instock_dialog.mo_ren_tong_shang') : ''" v-model="item.inUser" style="width: 100%"></el-input>
                      </el-col>
                      <!-- 入库时间 -->
                      <el-col :span="4">
                        <custom-date-picker
                          style="width: 100%"
                          v-model="item.inTime"
                          type="date"
                          value-format="YYYY-MM-DD HH:mm:ss"
                          :placeholder="index !== 0 ? $t('dms_instock_dialog.mo_ren_tong_shang') : $t('Common.com_please_select')"
                          :picker-options="beforeToday"
                        ></custom-date-picker>
                      </el-col>
                    </el-row>
                    <div class="icon-box" @click="deleteModel(index)">
                      <i v-if="index !== 0" class="icon icon-shanchu"></i>
                    </div>
                  </div>
                  <div class="add-child-btn" @click="addModel">
                    <div style="display: inline-block">
                      <i class="icon icon-add"></i>
                      <span>{{ $t('Common.com_added') }}</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveConfirm">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      visible: false,
      orgOptions: [],
      loading1: false,
      productOptions: [],
      radio: false,

      formItem: {
        bodyNum: '',
        productCode: '',
        productSn: '',
        inTime: '',
        inUser: '',
        modemSn: '',
        productBrand: '', // 新加
      },
      form: {
        // orgId: '',
        // orgName: '',
        shipmentNum: '',
      },
      productList: [],
    };
  },
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.init();
  },

  computed: {
    rules() {
      return {
      };
    },
  },
  methods: {
    // 初始化
    init: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.form = JSON.parse(this.resetForm);
      const models = [];
      models.push(JSON.parse(JSON.stringify(this.formItem)));
      models.push(JSON.parse(JSON.stringify(this.formItem)));
      models.push(JSON.parse(JSON.stringify(this.formItem)));
      models.push(JSON.parse(JSON.stringify(this.formItem)));
      models.push(JSON.parse(JSON.stringify(this.formItem)));
      this.productList = models;
      // this.remoteMethod();
      this.getProductList();
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    changProductSn: function (sItem, item) {
      if (sItem) {
        item.productCode = sItem.productCode || '';
      }
      // item.productBrand = modelObj.productBrand || '';
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // // 选择库存方
    // selectOrgan: function (value) {
    //   const item = this.orgOptions.find(t => `${t.partnerOrgId}` === `${value}`) || {};
    //   this.form.orgName = item.partnerName;
    // },
    // 库存方检索
    // remoteMethod: function (query) {
    //   this.loading1 = true;
    //   this.$getJSON(apis.OrganAllRoot, { orgName: query }).then((res) => {
    //     this.loading1 = false;
    //       const list = res.data;
    //       this.orgOptions = query
    //         ? list.filter(
    //           item => item.orgName.toLowerCase().indexOf(query.toLowerCase()) > -1
    //         )
    //         : list;
    //   });
    // },
    // 产品型号下拉列表
    getProductList: function () {
      this.$getJSON(apis.ProductModelList, { modelCode: '' }).then((res) => {
        this.productOptions = res.data;
      });
    },
    // 新增设备
    addModel: function () {
      this.productList.push(JSON.parse(JSON.stringify(this.formItem)));
    },
    // 删除设备
    deleteModel: function (index) {
      this.productList.splice(index, 1);
    },
    // 保存入库设备
    saveConfirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        const effective = this.productList.filter(t => t.bodyNum || t.modemSn);
        if (effective.length === 0) {
          this.$message.error(this.$t('dms_instock_dialog.qtxsbxx'));
          return;
        }
        if (!effective[0].inTime || !effective[0].inUser || !effective[0].productSn) {
          this.$message.error(this.$t('dms_instock_dialog.qjsbxxtxwz'));
          return;
        }
        const hasEmpty = effective.find(t => (!t.bodyNum && t.modemSn) || (t.bodyNum && !t.modemSn));
        if (hasEmpty) {
          this.$message.error(this.$t('dms_instock_dialog.qjsbxxtxwz'));
          return;
        }
        // 数据处理
        let productSn = '';
        // const productBrand = '';
        let inUser = '';
        let inTime = '';
        effective.forEach((item) => {
          item.orgId = this.form.orgId;
          item.orgName = this.form.orgName;
          item.shipmentNum = this.form.shipmentNum;
          if (item.productSn) {
            productSn = item.productSn;
            // productBrand = item.productBrand;
          } else {
            item.productSn = productSn;
            // item.productBrand = productBrand;
          }
          if (item.inUser) {
            inUser = item.inUser;
          } else {
            item.inUser = inUser;
          }
          if (item.inTime) {
            inTime = item.inTime;
          } else {
            item.inTime = inTime;
          }
        });
        this.saveInStock(effective);
      });
    },
    // 保存
    saveInStock: function (effective) {
      this.$postJSON(apis.InStock, effective).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.clearKeepAlive('stockRecord');
        this.clearKeepAlive('stockManage');
        this.$emit('success');
        this.closeDialog();
      });
    },
  },
};
</script>

<style lang="scss">
.instock-dialog-bd {
  .title {
    font-size: 16px;
    line-height: 24px;
    position: relative;
    padding-left: 12px;
    margin-bottom: 20px;
    color: #262626;
  }
  .title .bar {
    left: 0;
    width: 4px;
    height: 15px;
    background-color: #00afff;
  }
  .role-list {
    ul li {
      margin-top: 10px;
      border: 1px solid rgba(228, 228, 228, 1);
      &:first-child {
        margin-top: 0;
      }
    }
    .item-head {
      background: rgba(245, 245, 245, 1);
      border-bottom: 1px solid rgba(228, 228, 228, 1);
      padding: 0 10px;
      h1 {
        line-height: 40px;
        font-size: 12px;
        color: #262626;
        font-weight: bold;
        text-indent: 6px;
      }
      .icon-box {
        width: 30px;
        margin-left: 10px;
      }
    }
    .children {
      padding: 15px 0;
      .item {
        padding: 5px 10px 0;
        &:first-child {
          padding-top: 0;
        }
        .icon-box {
          line-height: 30px;
          width: 30px;
          margin-left: 10px;
          text-align: center;
          .icon {
            color: #00afff;
            font-size: 14px;
            cursor: pointer;
          }
        }
      }
      .el-input-group__append {
        border-radius: 0;
        .copy-up {
          padding: 0 8px;
          .el-radio__label {
            padding-left: 5px;
          }
        }
      }
    }
  }
  .other-role {
    margin-top: 30px;
  }

  .add-child-btn {
    background: rgba(245, 245, 245, 1);
    border: 1px dashed rgba(228, 228, 228, 1);
    line-height: 30px;
    text-align: center;
    color: #333333;
    font-size: 12px;
    margin: 14px 10px 0;
    cursor: pointer;
    .icon {
      color: #00afff;
      font-size: 10px;
      margin-right: 8px;
      float: left;
    }
  }
}
</style>
